// extracted by mini-css-extract-plugin
export default {"EmailOptIn":"EmailOptInp2EBd","emailOptIn":"EmailOptInp2EBd","checkbox":"checkboxS1m26"};